import React from 'react';
import { components } from 'react-select';
import cx from 'classnames/bind';
import styles from './compositeSettingOption.module.scss';
import { getCompositeSettingInvalidHint } from 'core/channelGroup/compositeSettingGate';

const classNames = cx.bind(styles);

/**
 * ECOPD-5722：素材類型下拉裡，所屬渠道合成設定不可用的選項。
 *
 * 原因寫在選項列內而不是 tooltip —— react-select 對 disabled 的選項會關掉滑鼠事件，
 * hover 本來就不會觸發。disabled 時回純 div 而不是 `components.Option`，沿用
 * `DraftL1ObjectOption` 的做法。
 */
export const CompositeSettingOption = (props) => {
  const optionClass = classNames('compositeSettingOption', {
    disabled: props.isDisabled
  });
  const renderOption = () => (
    <div className={optionClass}>
      <div className={styles.creativeTypeName}>{props.label}</div>
      {props.isDisabled && (
        <div className={styles.hint}>{getCompositeSettingInvalidHint()}</div>
      )}
    </div>
  );
  return !props.isDisabled ? (
    <components.Option {...props}>{renderOption()}</components.Option>
  ) : (
    renderOption()
  );
};
